import { Vertical } from 'component/Vertical'
import { observer } from 'mobx-react-lite'
import { EmployeeModal } from 'page/catalog/employee/EmployeeModal/EmployeeModal'
import { employeeModal } from 'page/catalog/employee/EmployeeModal/EmployeeModalStore'

export const EmployeeBoutiquePage = observer(() => {
  return <Vertical tall wide>
    {employeeModal.present && <EmployeeModal />}
  </Vertical>
})
